// CRAM Finance — Affiliate / Outbound Link Registry
// -----------------------------------------------------------------------------
// Currently educational links (issuer signup/info pages). Swap any URL below
// for your real affiliate tracking link when you have it. Keys = product slugs
// from /app/frontend/src/data/products.js
//
// Each entry has:
//   url:   where the CTA button sends users (opens in new tab)
//   label: (optional) overrides the default "Apply at {Issuer}" button text
// -----------------------------------------------------------------------------

export const affiliateLinks = {
  // ── Checking accounts ─────────────────────────────────────────────
  "sofi-checking-savings": {
    url: "https://www.sofi.com/banking/",
  },
  "chime-checking": {
    url: "https://www.chime.com/checking-account/",
  },
  "capital-one-360": {
    url: "https://www.capitalone.com/bank/",
  },
  "chase-secure-banking": {
    url: "https://account.chase.com/consumer/banking/secure",
  },
  "bofa-student-banking": {
    url: "https://www.bankofamerica.com/deposits/checking/advantage-banking/",
  },
  "axos-rewards-checking": {
    url: "https://www.axosbank.com/personal/bank/checking-accounts",
  },
  "wells-fargo-clear-access-banking": {
    url: "https://www.wellsfargo.com/checking/clear-access-banking/",
  },

  // ── Savings accounts ──────────────────────────────────────────────
  "sofi-savings": {
    url: "https://www.sofi.com/banking/high-yield-savings-account/",
  },
  "apple-bank-smartstart": {
    url: "https://www.applebank.com/personal/savings/youth-savings/smartstart-savings-for-young-adults-18-25",
  },
  "synchrony-hys": {
    url: "https://www.synchrony.com/lp/savings",
  },
  "varo-savings": {
    url: "https://www.varomoney.com/savings-account/",
  },
  "ally-online-savings": {
    url: "https://www.ally.com/bank/online-savings-account/",
  },
  "capital-one-savings": {
    url: "https://www.capitalone.com/bank/savings-accounts/online-performance-savings-account/features/",
  },
  "marcus-goldman-sachs-savings": {
    url: "https://www.marcus.com/us/en/savings/high-yield-savings",
  },

  // ── Budgeting apps ────────────────────────────────────────────────
  "ynab": {
    url: "https://www.ynab.com/",
    label: "Try YNAB",
  },
  "pocketguard": {
    url: "https://pocketguard.com/pricing/",
    label: "Try PocketGuard",
  },
  "goodbudget": {
    url: "https://goodbudget.com/what-you-get/",
    label: "Try Goodbudget",
  },
  "monarch-money": {
    url: "https://www.monarch.com/",
    label: "Try Monarch Money",
  },
  "quicken-simplifi": {
    url: "https://www.quicken.com/products/simplifi/",
    label: "Try Quicken Simplifi",
  },
  "everydollar": {
    url: "https://www.ramseysolutions.com/money/everydollar",
    label: "Try EveryDollar",
  },

  // ── Finance apps ──────────────────────────────────────────────────
  "empower": {
    url: "https://www.empower.com/",
    label: "Try Empower",
  },
  "credit-karma": {
    url: "https://www.creditkarma.com/lp/free-credit-scores-v12a?s=ggl-nb_acq&adcampaign=core_acq_ggl-search_all-web_none_notarget_non-brand_exact_alldevices_ios-tracking-test_2023-06-07&adgroup=App&exp=freeCreditScores&gclsrc=aw.ds&gad_source=1&gad_campaignid=20266610103&gbraid=0AAAAADrT-VfMmn4_00DSG7z5XRnvan7xp&gclid=CjwKCAjwgO7RBhBKEiwAZNP85k-PvMkg2S3-PCm2SITtqr9ld-KoEdyWw9YaWn6E1hksr_WJ6-aPRoCq5QQAvD_BwE",
    label: "Open Credit Karma",
  },
  "rocket-money": {
    url: "https://www.rocketmoney.com/",
    label: "Try Rocket Money",
  },
  "oportun-set-save": {
    url: "https://oportun.com/savings/",
    label: "Try Oportun Set & Save",
  },
  "cleo": {
    url: "https://web.meetcleo.com/",
    label: "Try Cleo",
  },

  // ── Investing apps ─────────────────────────────────────────────────
  robinhood: {
    url: "https://robinhood.com/",
    label: "View Robinhood",
  },
  webull: {
    url: "https://www.webull.com/",
    label: "View Webull",
  },
  "public-com": {
    url: "https://public.com/",
    label: "View Public.com",
  },
  "fidelity-youth-account": {
    url: "https://www.fidelity.com/go/youth-account/overview",
    label: "View Fidelity Youth Account",
  },
  acorns: {
    url: "https://www.acorns.com/",
    label: "View Acorns",
  },

  // ── Student credit cards ──────────────────────────────────────────
  "discover-it-student-cash-back": {
    url: "https://www.discover.com/products/student-it-co/?sc=RJQS&iq_id=r195629701086-601509675357&cmpgnid=ps-dca-google-student-brand-cashback&source=PSGOOGLE&gclsrc=aw.ds&gad_source=1&gad_campaignid=23889310699&gbraid=0AAAAAD7pg9z9cCMBvUCh0Ol5JK1xRCOUC&gclid=CjwKCAjwgO7RBhBKEiwAZNP850_giYaE3G7B6R9gPr4nHzXAS6QUZW0NmjE71kAxAveJfci_wN2UihoC5e0QAvD_BwE",
    label: "Apply at Discover",
  },
  "capital-one-savor-student": {
    url: "https://www.capitalone.com/credit-cards/savor-student/",
    label: "Apply at Capital One",
  },
  "capital-one-quicksilver-student": {
    url: "https://www.capitalone.com/credit-cards/quicksilver-student/",
    label: "Apply at Capital One",
  },
  "chase-freedom-rise": {
    url: "https://creditcards.chase.com/cash-back-credit-cards/freedom/rise",
    label: "Apply at Chase",
  },
  "bofa-travel-rewards-student": {
    url: "https://www.bankofamerica.com/credit-cards/products/student-rewards-credit-card/",
    label: "Apply at Bank of America",
  },
};

/**
 * Get the outbound link + button label for a product slug.
 * Falls back to "#" with a default label if no entry exists.
 */
export function getAffiliate(slug, fallbackLabel = "Learn more") {
  const entry = affiliateLinks[slug];
  if (!entry) return { url: "#", label: fallbackLabel, configured: false };
  return { url: entry.url, label: entry.label || fallbackLabel, configured: true };
}
